<template>
<div>
  <div id="modal-log" class="modal fade" aria-hidden="false" ref="shellLog" v-if="logs">
    <div class="modal-dialog">
      <div class="">
        <div class="modal-body ibox">
          <div class="col-lg-12">
            <div class="ibox ">
              <div class="ibox-title">
                <h5>Log for {{ shell }}</h5>
                <div class="ibox-tools">
                  <a class="close-modal" data-dismiss="modal">
                    <i class="fa fa-times"></i>
                  </a>
                </div>
              </div>
              <div class="ibox-content">
                <div class="row" v-for="log in logs" :key="log.id">
                    <table class="table table-hover">
                      <tbody>
                      <tr>
                        <td><strong>{{ $moment(log.addedTime.date).format('DD.MM.YYYY HH:mm') }}</strong></td>
                      </tr>
                      <tr v-for="(msg, i) in log.messages" :key="'msg-'+i">
                        <td>
                          {{ msg }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  <hr>
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Description</th>
                      <th>Expected</th>
                      <th>Got</th>
                      <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(res, i) in log.results" :key="'res-'+i">
                      <td>
                        {{ res.desc }}
                      </td>
                      <td>
                        {{ res.expected }}
                      </td>
                      <td>
                        {{ res.received }}
                      </td>
                      <td>
                        <i v-if="res.success" class="fa fa-check-circle" title="'OK'" style="color: forestgreen"></i>
                        <i v-else class="fa fa-times-circle" title="'Failed'" style="color: red"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="wrapper wrapper-content animated fadeInUp">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Upload</h5>
          </div>
          <div class="ibox-content" v-if="upload">
            <strong>{{ upload.user.username }}</strong> @ <strong>{{ $moment(upload.time.date).format('DD.MM. HH:mm') }}</strong>
            <br>
            Count: <strong>{{ upload.new + upload.bad + upload.old }}</strong> |
            New: <strong style="color: forestgreen">{{ upload.new }}</strong> |
            Old: <strong style="color: orange">{{ upload.old }}</strong> |
            Bad: <strong style="color: red">{{ upload.bad }}</strong>
            <br>
            <span @click="processBatch">Reprocess</span>
          </div>
          <div class="ibox-content">
            <div class="row m-b-sm m-t-sm">
              <div class="ibox">
                <div class="ibox-content">
                  <div class="row">
                    <table class="table table-hover">
                      <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>Shell</th>
                        <th>WPs</th>
                        <th>&nbsp;</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ul, i) in uploads" :key="ul.id">
                        <td>{{ i + 1 }}</td>
                        <td><a @click="showLog(ul.url)"><i class="fa fa-bars" title="Log"></i></a></td>
                        <td class="center" v-if="ul.success">
                          <i v-if="ul.new" class="fa fa-check-circle" :title="'New'" style="color: forestgreen"></i>
                          <i v-else class="fa fa-check-circle" :title="'Old'" style="color: orange"></i>
                        </td>
                        <td  class="center" v-else>
                          <i class="fa fa-times-circle" :title="'Bad'" style="color: red"></i>
                        </td>
                        <td>{{ ul.url }}</td>
                        <td>{{ ul.wpCount || '/' }}</td>
                        <td>
                          <a @click="processUpload(ul.id)"><i class="fa fa-repeat" title="Reprocess" style="color: forestgreen"></i></a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: 'Yo',
      uploads: [],
      uploadId: this.$route.params.id,
      upload: null,
      logEntry: null,
      logs: null,
      shell: null
    }
  },
  mounted () {
    this.loadUploads(this.uploadId)
  },
  methods: {
    loadUploads (id) {
      axios.get('/xs/upload-breakdown/' + id)
        .then(r => {
          this.uploads = r.data.shells
          this.upload = r.data.upload
        })
    },
    getLog (url) {
      axios.get('/log?shell=' + url)
        .then(r => {
          this.logs = r.data
        })
    },
    showLog (url) {
      this.shell = url
      $('#modal-log').modal('show')
      this.getLog(url)
    },
    processUpload (id) {
      axios.post('/xs/uploads/process', {
        id: id
      })
        .then(r => {
          console.log('goodie')
          // We iz good.
        })
    },
    processBatch () {
      axios.post('/xs/uploads/process-batch', {
        id: this.upload.id
      })
        .then(r => {
          console.log(r.data)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Xs/Upload.vue